export const PAYSLIP_TEMPLATES = [
  { id: 'classic', label: 'Sample 1 · Classic', description: 'Company banner with a strong colour header.' },
  { id: 'minimal', label: 'Sample 2 · Minimal', description: 'Light header with a clean accent line.' },
];
export const PAYSLIP_COLOURS = [
  { id: 'navy', label: 'Navy', hex: '#1a3a5c', rgb: [26, 58, 92], tint: [235, 241, 248] },
  { id: 'slate', label: 'Gray', hex: '#475569', rgb: [71, 85, 105], tint: [241, 245, 249] },
  { id: 'teal', label: 'Teal', hex: '#0f766e', rgb: [15, 118, 110], tint: [236, 253, 245] },
  { id: 'plum', label: 'Plum', hex: '#6b416c', rgb: [107, 65, 108], tint: [248, 240, 249] },
];
export function normalizePayslipStyle(style) {
  return {
    template: PAYSLIP_TEMPLATES.some(item => item.id === style?.template) ? style.template : 'classic',
    colour: PAYSLIP_COLOURS.some(item => item.id === style?.colour) ? style.colour : 'navy',
  };
}
export function getPayslipTheme(style) {
  const normalized = normalizePayslipStyle(style);
  return { ...normalized, palette: PAYSLIP_COLOURS.find(item => item.id === normalized.colour) };
}
export async function saveCompanyPayslipStyle(client, companyId, style) {
  if (!companyId) throw new Error('Save the company before choosing its payslip style.');
  const { data, error } = await client.from('companies').select('config').eq('id', companyId).single();
  if (error) throw error;
  const currentConfig = data.config;
  const normalized = normalizePayslipStyle(style);
  let update = client.from('companies').update({ config: { ...(currentConfig || {}), payslip_style: normalized } }).eq('id', companyId);
  update = currentConfig == null ? update.is('config', null) : update.eq('config', JSON.stringify(currentConfig));
  const result = await update.select('id');
  if (result.error) throw result.error;
  if (result.data?.length !== 1) throw new Error('Company settings changed in another session. Please retry saving the style.');
  return normalized;
}
